module.exports = __webpack_public_path__ + "img/sandford.58b3a663.png";